<div id="login" fxLayout="column">

    <div *ngIf="!loading" id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
                <img src="assets/images/logos/logoM.png">
            </div>

            <div class="title">{{ 'AUTHENTICATION.INITIAL_TEXT' | translate }}</div>

            <form name="loginForm" [formGroup]="loginForm" novalidate>

                <button mat-raised-button type="submit" color="accent" class="submit-button" aria-label="LOG IN"
                (click)="facelogin()" *ngIf="!muestraCamara && !muestraLogin && !muestraBuscarCliente">
                        Face  Login
                </button>
                <mat-form-field appearance="outline" *ngIf="muestraBuscarCliente">
                    <mat-label>{{ 'AUTHENTICATION.EMAIL' | translate }}</mat-label>
                    <input #email matInput formControlName="emailBuscar">
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                </mat-form-field>
                <button mat-raised-button color="accent" class="submit-button"
                        aria-label="UPDATE AN ACCOUNT" (click)="buscarCliente()" *ngIf="muestraBuscarCliente">
                        Acceder
                </button>
                <button mat-raised-button color="accent" class="submit-button"
                        aria-label="UPDATE AN ACCOUNT" (click)="muestraBuscarCliente = false;" *ngIf="muestraBuscarCliente">
                        Cancelar
                </button>
               
                <div class="logo">
                    <img  width="250px" height="200px" src="assets/img/scan.gif"  *ngIf="muestraCamara">
                </div>
                 <button mat-raised-button color="accent" class="submit-button"
                        aria-label="UPDATE AN ACCOUNT" (click)="cancelfacelogin()" *ngIf="muestraCamara">
                        Cancelar
                </button>
                <button mat-raised-button type="submit" color="accent" class="submit-button" aria-label="LOG IN"
                (click)="muestraLogin = true" *ngIf="!muestraLogin && !muestraCamara && !muestraBuscarCliente && muestraManual">
                        Login Manual
                </button>
              
               
                <p>
                    <video hidden #video id="myvideo" class="vid" autoplay  *ngIf="muestraCamara"></video>
                </p>
                <mat-form-field appearance="outline" *ngIf="muestraLogin">
                    <mat-label>{{ 'AUTHENTICATION.EMAIL' | translate }}</mat-label>
                    <input #email matInput formControlName="email"  (keypress)="eventHandler($event)">
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                    <mat-error *ngIf="loginForm.get('email').hasError('required')">
                        {{ 'AUTHENTICATION.EMAIL_REQUIRED' | translate }}
                    </mat-error>
                    <mat-error *ngIf="!loginForm.get('email').hasError('required') &&
                                loginForm.get('email').hasError('email')">
                        {{ 'AUTHENTICATION.INVALID_EMAIL' | translate }}
                    </mat-error>
                </mat-form-field>

                

                <mat-form-field appearance="outline" *ngIf="muestraLogin">
                    <mat-label>{{ 'AUTHENTICATION.PASSWORD' | translate }}</mat-label>
                    <input matInput type="password" formControlName="password"  value="cobros2024"  (keypress)="eventHandler($event)">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error>
                        {{ 'AUTHENTICATION.PASSWORD_REQUIRED' | translate }}
                    </mat-error>
                </mat-form-field>
<!-- RECUPERAR CONTRASEÑA TODO
    <div class="remember-forgot-password" fxLayoutAlign="end"  *ngIf="muestraLogin">
        
        <a class="forgot-password" [routerLink]="'/pages/auth/forgot-password'">
            {{ 'AUTHENTICATION.FORGOT_PASSWORD' | translate }}
        </a>
    </div>
    
-->
                <button mat-raised-button type="submit" color="accent" class="submit-button" aria-label="LOG IN"
                    [disabled]="loginForm.invalid" (click)="login()"  *ngIf="muestraLogin">
                    {{ 'AUTHENTICATION.LOGIN' | translate }}
                </button>
                <!--

                    <button mat-raised-button color="accent" class="submit-button"
                    aria-label="UPDATE AN ACCOUNT" (click)="muestraLogin = false" *ngIf="muestraLogin">
                    CANCEL
                </button>           
            -->


            </form>

            <div class="register" fxLayout="column" fxLayoutAlign="center center">
                <span class="text">{{ 'AUTHENTICATION.NO_ACCOUNT' | translate }}</span>
                <a class="link"
                    [routerLink]="'/pages/auth/register'">{{ 'AUTHENTICATION.CREATE_ACCOUNT' | translate }}</a>
            </div>
<!--

    <div class="register" fxLayout="column" fxLayoutAlign="center center">
        <span class="text">{{ 'AUTHENTICATION.WANT_VERIFY' | translate }}</span>
        <a class="link"
        [routerLink]="'/pages/document/verify'">{{ 'AUTHENTICATION.DOCUMENT_VERIFICATION' | translate }}</a>
    </div>
    
-->
            <div style="position: absolute; margin-bottom: 2px; left:10px; font-size: xx-small; color: white">
               (c) Makensia 2025 - v2.4.3 - Abril 2025
            </div>
        </div>

    </div>

    <app-loading *ngIf="loading"></app-loading>

</div>